module.exports = __webpack_public_path__ + "static/img/icon-pdf.cb71a181.jpg";